import { AlertDialog } from '../../AlertDialog/AlertDialog';

export interface WithholdingsConfirmModalProps {
  open: boolean;
  /** Título del diálogo. */
  title: string;
  /** Cuerpo / descripción. */
  body: string;
  /** Texto del botón de confirmación. */
  confirmLabel: string;
  /** Texto del botón de cancelar. */
  cancelLabel: string;
  /** `warning` para Recalcular, `danger` para Eliminar. @default 'warning' */
  type?: 'warning' | 'danger';
  /** Mutación en vuelo: bloquea botones y muestra spinner. */
  isLoading: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

/**
 * Modal de confirmación genérico del panel de retenciones (FEAT-105-11.03).
 *
 * Envuelve el `AlertDialog` del kit; sirve para Recalcular (`warning`) y para
 * Eliminar (`danger`). Reutilizable por cualquier acción que requiera confirmar.
 */
export function WithholdingsConfirmModal({
  open,
  title,
  body,
  confirmLabel,
  cancelLabel,
  type = 'warning',
  isLoading,
  onConfirm,
  onClose,
}: WithholdingsConfirmModalProps) {
  return (
    <AlertDialog
      isOpen={open}
      type={type}
      title={title}
      description={body}
      cancelText={cancelLabel}
      confirmText={confirmLabel}
      isProcess={isLoading}
      preventCloseOnOverlayClick
      onCancel={onClose}
      onConfirm={onConfirm}
    />
  );
}
